<template>

  <div class="container" id="nav600-items">
    <div class="row text-center">

      <b-col lg="2" sm="12">
        <m-a :href="{name:'Home'}">
          <img :src="findAttributeOnSiteInfo('icon')[0]" :alt="findAttributeOnSiteInfo('site_name')[0]"
               class="nav601-logo"></m-a>
      </b-col>


      <b-col lg="10" class="ml-auto mr-auto col-sm-12 text-lg-right col-lg-10" sm="12">

        <div class="d-inline" v-for="menu in storeMenus" :key="menu.id"
             v-if="menu.position === 'store_nav'">
          <NavMenuItem v-for="item in menu.children" :item="item" :key="item.id"/>
        </div>

        <m-a class="d-inline text-dark ml-3 custom-font-size" v-if="!isAuth" :href="{name:'Login'}">ورود/ثبت نام</m-a>
        <m-a class="d-inline text-dark ml-3 custom-font-size" v-else :href="{name:'Dashboard'}">داشبورد</m-a>


      </b-col>

    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import NavMenuItem from "./NavMenuItem"

export default {
  name: "Nav601",
  components: {NavMenuItem},
  computed: {
    ...mapGetters({
      storeMenus: "Menu/getStoreMenus",
      isAuth: "User/isAuthenticated",
      orderCount: 'ShoppingCart/getSidebarBasketData',
    }),
  },
}

</script>


<style scoped>
.nav601-logo {
  height: auto;
  width: 80px;
}

.custom-font-size{
  font-size: 12px;
  font-weight: bold;
}

</style>